
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/leftBar/leftPanelFrame/leftPanelFrame.scss.css.virtualfile';
        module.exports = {"leftPanelFrame":"_leftPanelFrame_107ko_7","emptyHeader":"_emptyHeader_107ko_41","contentContainer":"_contentContainer_107ko_108"};